// src/data/bindingProducts.js
// Scope code (reports.json key / filename prefix) -> human display name.
// Source: the sync-metric-reports site's index.js productNameMapping.
export const productNameMapping = {
  MB_WRL: "Orbis Mini-Binding",
  OA_WRL: "Orbis AdHoc",
  OA_KOR: "Orbis AdHoc Korea",
  OB_WRL: "Orbis Bifrost",
  OF_WRL: "Orbis Everflow",
  OLM_WRL: "Orbis LaneModel",
  ON_WRL: "Orbis NexVentura",
  ON_KOR: "Orbis NexVentura KOR",
  ONA_WRL: "Orbis NexVentura ADAS",
  ONAKOR_KOR: "Orbis NexVentura ADAS KOR",
  OV_WRL: "Orbis Ventura",
  OT_GLOBAL: "Overture Transportation",
  TTMPO_WRL: "Tempo",
};

// Only Orbis-branded products are shown (isProductAllowed checks the display name).
// PRODUCT_PREFIX_ALLOWLIST narrows further by exact scope; empty = no extra narrowing.
export const PRODUCT_PREFIX_ALLOWLIST = [];

export function isProductAllowed(scope) {
  // Only products whose display name contains "Orbis" appear in the picker.
  if (!/orbis/i.test(productDisplayName(scope))) return false;
  return (
    PRODUCT_PREFIX_ALLOWLIST.length === 0 ||
    PRODUCT_PREFIX_ALLOWLIST.includes(scope)
  );
}

export function productDisplayName(scope) {
  return productNameMapping[scope] || scope;
}
